import { render, staticRenderFns } from "./NovelDeleteConfirm.vue?vue&type=template&id=1843c404&scoped=true"
import script from "./NovelDeleteConfirm.vue?vue&type=script&lang=ts"
export * from "./NovelDeleteConfirm.vue?vue&type=script&lang=ts"
import style0 from "./NovelDeleteConfirm.vue?vue&type=style&index=0&id=1843c404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843c404",
  null
  
)

export default component.exports